import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateOptions } from '@common/data-models/navigation/viewstate-options';
import { ViewStateOptionsSerializer } from '@common/data-models/serializers/serializers';
import { ViewStateTypes } from '@common/enums/viewstate-types';

import { Record } from './record';
import { SearchViewStateRecord } from './search-viewstate-record';

export class WireSearchViewStateRecord extends SearchViewStateRecord {
    public initialize() {
        super.initialize();
        this.viewStateType = ViewStateTypes.WIRESEARCH;
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }

    public get viewStateLayout(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateLayout');
    }
    public set viewStateLayout(value: ViewStateOptions) {
        this.set('PSTViewStateLayout', value);
    }
}
